import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

export type CloudActivationAddress = {
  localizacao: {
    latitude: number;
    longitude: number;
  };
  cityName: string;
  street: string;
  neighborhood: string;
  zipCode: string;
  complement?: string;
  reference?: string;
  number?: string;
};

type PostCloudActivationParams = {
  isActivateCloud: boolean;
  isReserveBase: boolean;
  establishmentId: string;
  address: CloudActivationAddress;
};

const postCloudActivation = async ({
  isActivateCloud,
  isReserveBase,
  establishmentId,
  address,
}: PostCloudActivationParams) =>
  apiClient
    .post(`/estabelecimentos/cloud-activation`, {
      isActivateCloud,
      isReserveBase,
      establishmentId,
      address,
    })
    .then(response =>
      handleResponseSuccess(
        response,
        isActivateCloud
          ? 'Estabelecimento aprovado com sucesso!'
          : 'Estabelecimento enviado para a base reserva com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível concluir a ativação na nuvem.',
      ),
    );

export const usePostCloudActivation = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PostCloudActivationParams> = {}) => {
  return useMutation({
    mutationFn: postCloudActivation,
    onSuccess: (...args) => {
      onSuccess?.(...args);
    },
    ...options,
  });
};
